import { MilestoneTask } from "./MilestoneTask";
import { MilestoneTaskReport } from "./MilestoneTaskReport";
import { MilestoneTaskReportResponse } from "./MilestoneTaskReportResponse";
import { MilestoneTaskResponse } from "./MilestoneTaskResponse";
import { ClockifyTimeEntriesReportMapper } from "../clockifyTimeEntries/ClockifyTimeEntriesReportMapper";

export class TaskReportResponseMapper {
  private clockifyMapper = new ClockifyTimeEntriesReportMapper();

  mapMilestoneTaskReportResponseToMilestoneTaskReport = (
    response: MilestoneTaskReportResponse
  ): MilestoneTaskReport => {
    return {
      id: response.id,
      totalTimeSpentOnTask: response.totalTimeSpentOnTask,
      lastPercentageComplete: response.lastPercentageComplete,
      developerName: response.developerName,
      milestoneTask: response.milestoneTask
        ? this.mapMilestoneTaskResponseToMilestoneTask(response.milestoneTask)
        : null,
      milestoneId: response.milestoneId,
      dateStart: response.dateStart,
      dateEnd: response.dateEnd,
      dateCreated: response.dateCreated,
      dateModified: response.dateModified,
    };
  };

  mapMilestoneTaskResponseToMilestoneTask = (
    response: MilestoneTaskResponse
  ): MilestoneTask => {
    return {
      id: response.id,
      gitLabTaskNumber: response.gitLabTaskNumber,
      taskTitle: response.taskTitle,
      timeEstimate: response.timeEstimate,
      milestoneId: response.milestoneId,
      dateCreated: response.dateCreated,
      dateModified: response.dateModified,
      taskReports: [],
      timeEntries:
        response.timeEntries && response.timeEntries.length > 0
          ? response.timeEntries.map((entry) =>
              this.clockifyMapper.mapClockifyTimeEntriesResponseToClockifyTimeEntry(
                entry
              )
            )
          : [],
    };
  };
}
